<template>
  <div class="single-activity" :class="{ 'single-activity--flex': showUserAvatar }">
    <user-avatar
      v-if="showUserAvatar"
      class="single-activity__user-avatar"
      aria-haspopup="true"
      :user="activity.user"
      size="full"
    />
    <div class="single-activity__user-content">
      <div
        v-if="showUsername"
        class="single-activity__username"
      >
        {{ activity.user.username }}
      </div>
      <div
        class="single-activity__body"
        @click="handleLinkClick"
        v-html="activity.body"
      />
      <div class="single-activity__subtext">
        <div
          v-if="showActivityType"
          class="single-activity__type"
        >
          {{ activityType }}
        </div>
        <time-stamp
          class="single-activity__timestamp"
          :date="activity.insertedAt"
          :show-date-stamp="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import handleLinkClick from '@/mixins/handle-link-click-mixin';
import TimeStamp from '@/components/Global/TimeStamp.vue';
import UserAvatar from '@/components/User/UserAvatar.vue';
import { assocTypeToText } from '@/utils/moderation-helpers';

export default {
  name: 'SingleActivity',
  components: {
    TimeStamp,
    UserAvatar,
  },
  mixins: [handleLinkClick],
  props: {
    activity: {
      type: Object,
      required: true,
    },
    showUserAvatar: {
      type: Boolean,
      default: false,
    },
    showUsername: {
      type: Boolean,
      default: false,
    },
    showActivityType: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activityType() {
      if (this.activity.assocType === 'user_profile_status') {
        return 'Status update';
      }
      if (this.activity.assocType === 'user_profile_status_reply') {
        return 'Reply to status';
      }
      if (this.activity.assocType === 'thread') {
        return 'Forum';
      }
      return assocTypeToText(this.activity.assocType);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_single-activity';
</style>

<style lang="scss"> // no scoped - for child element selectors
  .single-activity__body img {
    display: block;
    padding-top: $spacing;
  }
</style>

<docs>
A single activity that is rendered in the Activity Stream.
It can show a user's avatar, name, type of activity based on where it
is being rendered.  It always shows the timestamp.

</docs>
